<template>
  <div class="main">
    <div class="content">
      <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/terrace/2.png" alt="" class="title">
      <div class="content">
        <div class="list" v-for="(item, index) of list" :key="item.title" :style="{'background-image': 'url('+ item.backImg +')'}">
          <img :src="item.icon" class="icon" alt="">
          <div class="headline">{{ item.title }}</div>
          <div class="desc">{{ item.desc }}</div>
          <div class="enter" @click="go(item.url)">点击进入</div>
        </div>
      </div>
      <div class="web">
        <div>2021 © 格如灵版权所有</div>
        <div>京ICP备 16064072号-1</div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      list: [{
        title: '灵匠',
        desc: ' 校级虚拟仿真教学平台',
        icon: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/terrace/10.png',
        backImg: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/terrace/6.png',
        url: 'http://pt.growlib.com'
      }, {
        title: '灵创',
        desc: ' 互动微课编辑器与资源平台',
        icon: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/terrace/9.png',
        backImg: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/terrace/5.png',
        url: 'http://creator.growlib.com/loginBefore'
      }, {
        title: '灵资',
        desc: ' 3D资产管理系统',
        icon: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/terrace/7.png',
        backImg: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/terrace/3.png',
        url: 'https://assets.growlib.cn'
      }],
      lock: true
    };
  },
  mounted() {
    let timer = setInterval(()=>{
      if(document.getElementById('newBridge') != null){
        document.getElementById('newBridge').style.display = 'none'
        clearInterval(timer)
      }
    },100)
  },
  methods: {
    go(url){
      if(!url){
        if(this.lock){
          this.lock = false
          this.$message('建设中')
          setTimeout(()=>{
            this.lock = true
          }, 3000)
        }
        return
      }
      window.open(url)
    }
  }
};
</script>
<style lang="less" scoped>
.main {
  background-color: #fff;
  background-image: url(https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/terrace/1.png);
  background-size: 100% 100%;
  .content{
    width: 1300px;
    height: 100vh;
    margin: 0 auto;
    position: relative;
    overflow: hidden;
    .title{
      width: 325px;
      display: block;
      margin: 0 auto;
      margin-top: 117px;
    }
    .content{
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin-top: 136px;
      position: relative;
      z-index: 1;
      .list{
        width: 300px;
        height: 420px;
        display: flex;
        flex-direction: column;
        align-items: center;
        background-size: 100% 100%;
        > div{
          text-align: center;
        }
        .icon{
          width: 86px;
          height: 86px;
          margin-top: 111px;
        }
        .headline{
          font-size: 24px;
          font-weight: 600;
          color: #FFFFFF;
          line-height: 33px;
          letter-spacing: 1px;
          margin-top: 43px;
        }
        .desc{
          font-size: 16px;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 22px;
          margin-top: 12;
        }
        .enter{
          width: 122px;
          height: 42px;
          background: #FFFFFF;
          box-shadow: 0px 2px 6px 0px rgba(114, 217, 255, 0.43);
          border-radius: 6px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 16px;
          font-weight: 400;
          color: #E18B23;
          line-height: 22px;
          margin-top: 40px;
          cursor: pointer;
        }
        .gray{
          color: #999;
        }
      }
    }
    .web{
      position: absolute;
      bottom: 50px;
      left: 0;
      width: 100%;
      >div{
        text-align: center;
        font-size: 12px;
        font-weight: 400;
        color: #B5B5B5;
        line-height: 18px;
      }
    }
  }
}
</style>
<style>
@media (max-width: 1500px){
  html[lang=zh-CN]{
    font-size: 260px !important;
  }
}
</style>
